module.exports = __webpack_public_path__ + "img/swipe3.e65e05ba.png";